import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CrossFadeImageSlider = ({
  images = [],
  width = '100%',
  height = '400px',
  rounded = ' ',
  className = ' ',
  style = {},
}) => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(null);

  useEffect(() => {
    if (!images.length) return;

    const interval = setInterval(() => {
      setPrev(current);
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [current, images.length]);

  return (
    <div
      style={style}
      className={`relative overflow-hidden rounded-xl ${width} ${height} ${className} `}
    >
      <AnimatePresence>
        {prev !== null && images[prev] && (
          <motion.img
            key={`prev-${prev}`}
            src={
              typeof images[prev] === 'string'
                ? images[prev]
                : images[prev]?.src
            }
            alt={typeof images[prev] === 'object' ? images[prev]?.alt : ''}
            initial={{ opacity: 1 }}
            animate={{ opacity: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1, ease: 'easeInOut' }}
            className={`absolute top-0 left-0 w-full h-full object-contain ${rounded}`}
          />
        )}
      </AnimatePresence>

      {images[current] && (
        <motion.img
          key={`current-${current}`}
          src={
            typeof images[current] === 'string'
              ? images[current]
              : images[current]?.src
          }
          alt={typeof images[current] === 'object' ? images[current]?.alt : ''}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, ease: 'easeInOut' }}
          className={`absolute top-0 left-0 w-full h-full object-contain ${rounded}`}
        />
      )}
    </div>
  );
};

export default CrossFadeImageSlider;
